"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./SelectedPlan.desktop.css");
require("./SelectedPlan.tablet.css");
require("./SelectedPlan.mobile.css");
var Label_1 = require("../../atoms/Label/Label");
var PriceContainer_1 = require("../../cards/PriceContainer/PriceContainer");
var PriceContainerProps_1 = require("../../cards/PriceContainer/PriceContainerProps");
var SelectedPlanProps_1 = require("./SelectedPlanProps");
var Link_1 = require("../../atoms/Link");
var icons = require("./../../../styles/att-icons.css");
var utils_1 = require("../../../utils/utils");
var Button_1 = require("../../atoms/Button/Button");
var accessibility_1 = require("../../../utils/accessibility");
var ButtonProps_1 = require("../../atoms/Button/ButtonProps");
var Modal_1 = require("../../atoms/Modal/Modal");
var ChangeText = 'Change';
var RemoveText = 'Remove';
var SelectedPlan = /** @class */ (function (_super) {
    __extends(SelectedPlan, _super);
    function SelectedPlan(props) {
        var _this = _super.call(this, props) || this;
        _this.hideChangeLink = _this.props.options.hideChangeLink ? true : false;
        _this.hideRemoveLink = _this.props.options.hideRemoveLink ? true : false;
        _this.showQuantity = (_this.props.data.quantity && _this.props.data.quantity > 1) ?
            ' (Qty. ' + _this.props.data.quantity + ')' : '';
        _this.onButtonClick = _this.onButtonClick.bind(_this);
        _this.onClose = _this.onClose.bind(_this);
        _this.state = {
            show: false,
        };
        return _this;
    }
    SelectedPlan.prototype.componentWillReceiveProps = function (nextProps) {
        this.hideChangeLink = nextProps.options.hideChangeLink ? true : false;
        this.hideRemoveLink = nextProps.options.hideRemoveLink ? true : false;
        this.showQuantity = (nextProps.data.quantity && nextProps.data.quantity > 1) ?
            ' (Qty. ' + nextProps.data.quantity + ')' : '';
    };
    SelectedPlan.prototype.onClose = function () {
        this.props.events.onLegalClose();
        this.setState(__assign(__assign({}, this.state), { show: false }));
    };
    SelectedPlan.prototype.onButtonClick = function () {
        this.props.events.onLegalClick();
        this.setState(__assign(__assign({}, this.state), { show: true }));
    };
    SelectedPlan.prototype.render = function () {
        var iconClasses = __spread([icons.attIcon, icons.attIconLg], this.getIconFromOps(this.props.options));
        var pricingType = window.innerWidth < 768 ? PriceContainerProps_1.PricingType.SMALL : PriceContainerProps_1.PricingType.FEATURED;
        var longOfferContent = this.props.data.longLegal;
        var legalTitle = this.props.data.legalTitle;
        var planTitle = this.props.data.title;
        if (this.showQuantity !== '') {
            planTitle += '  ' + '<span class="SelectedPlan__quantity-title">' + this.showQuantity + '</span>';
        }
        var modalContent = {
            modalContentClass: styles.modalContent,
            modalMaskClass: '',
            modalParentClass: '',
        };
        if (this.props.data.price === undefined && !this.props.options.isInternationalPackage) {
            throw new Error('you must pass price or priceButtonData props the data props');
        }
        var labelOptions = {};
        if (this.props.options) {
            labelOptions = accessibility_1.getAccessibilityOptions(this.props.options);
        }
        return (React.createElement("div", { "data-test-id": this.props.testId, className: styles.selectedPlanContainer },
            React.createElement("div", { className: styles.selectedPlanInner },
                React.createElement("div", { className: styles.selectedPlanIcon },
                    React.createElement("i", { className: iconClasses.join(' '), role: "img", "aria-hidden": "true" })),
                React.createElement("div", { className: styles.selectedPlanContent },
                    React.createElement("div", { className: styles.content },
                        React.createElement("div", { className: styles.contentText },
                            this.props.options.heading &&
                                React.createElement("div", { className: styles.selectedPlanHeading, tabIndex: 0 }, this.props.options.heading),
                            React.createElement(Label_1.default, { testId: utils_1.default('Label', 'TitlePrice'), data: { text: planTitle }, options: __assign({ className: styles.planTitleName }, labelOptions) }),
                            React.createElement("br", { className: styles.divider }),
                            this.props.data.subtitle &&
                                React.createElement(Label_1.default, { testId: utils_1.default('Label', 'PlanSubtitle'), data: { text: this.props.data.subtitle }, options: {
                                        className: this.props.options.isInternationalPackage ?
                                            styles.planSubtitle + ' ' + styles.planSubtitleSmall :
                                            styles.planSubtitle,
                                        tabIndex: 0,
                                    } }),
                            (!this.hideChangeLink && this.props.events.onChange !== undefined) && React.createElement(Link_1.default, { testId: utils_1.default(this.props.testId, 'Link', 'ChangePlan'), data: { content: this.props.data.changeLinkLabel || ChangeText }, events: { onClick: this.props.events.onChange }, options: { className: styles.changePlan } }),
                            (!this.hideRemoveLink && this.props.events.onRemove !== undefined) &&
                                React.createElement(Link_1.default, { testId: utils_1.default(this.props.testId, 'Link', 'RemovePlan'), data: { content: this.props.data.removeLinkLabel || RemoveText }, events: { onClick: this.props.events.onRemove }, options: { className: styles.removePlan } })),
                        this.props.options.supressPriceSection ? '' :
                            this.props.options.isInternationalPackage ?
                                (React.createElement(Button_1.default, { data: { text: this.props.data.buttonText || 'See packages' }, events: { onClick: this.props.events.onButtonClick }, options: { type: ButtonProps_1.ButtonType.GHOST, className: styles.intnlPkgButton } }))
                                : (React.createElement("div", { className: styles.priceContent },
                                    React.createElement("div", { className: styles.priceAlign }, (this.props.data.discountedPrice && this.props.data.discountedPrice.price !== undefined &&
                                        this.props.data.discountedPrice.price !== this.props.data.price.price) ? (React.createElement(React.Fragment, null,
                                        React.createElement(PriceContainer_1.default, { testId: utils_1.default(this.props.testId, 'PriceContainer'), data: this.props.data.price, options: {
                                                className: styles.strikePrice,
                                                decimalPoints: 2,
                                                type: pricingType,
                                            } }),
                                        React.createElement(PriceContainer_1.default, { testId: utils_1.default(this.props.testId, 'PriceContainer'), data: this.props.data.discountedPrice, options: {
                                                className: styles.planTitlePrice,
                                                decimalPoints: 2,
                                                displayFree: this.props.options.displayFree,
                                                displayFreeText: this.props.options.displayFreeText,
                                                type: pricingType,
                                            } }))) :
                                        (React.createElement(PriceContainer_1.default, { testId: utils_1.default(this.props.testId, 'PriceContainer'), data: this.props.data.price, options: {
                                                className: styles.planTitlePrice,
                                                decimalPoints: 2,
                                                displayFree: this.props.options.displayFree,
                                                displayFreeText: this.props.options.displayFreeText,
                                                type: pricingType,
                                            } }))),
                                    this.props.data.seeOfferDetailLinkLabel !== undefined &&
                                        React.createElement(React.Fragment, null,
                                            React.createElement(Label_1.default, { testId: utils_1.default('Label', 'OfferShortLegal'), data: { isDecodingRequired: false,
                                                    text: this.props.data.shortLegal }, options: { className: styles.offerShortLegal } }),
                                            React.createElement(Link_1.default, { data: { content: this.props.data.seeOfferDetailLinkLabel }, events: { onClick: this.onButtonClick }, options: { accessibility: 'link', className: styles.offerShortLegal } }),
                                            React.createElement(Modal_1.default, { testId: "See_Offers_Modal", options: { className: modalContent, show: this.state.show, showClose: true,
                                                    tabIndex: 0 }, events: { onClose: this.onClose }, accessibilityText: this.props.data.seeOfferDetailLinkLabel },
                                                React.createElement("div", null,
                                                    React.createElement("h4", { className: "modal-content-heading" }, legalTitle),
                                                    React.createElement("p", { className: "modal-content-text", dangerouslySetInnerHTML: { __html: longOfferContent } }))))))),
                    this.props.children))));
    };
    /*
      getPriceContainer() {
        if (this.props.data.price !== undefined) {
          const pricingType = window.innerWidth < 768 ? PricingType.SMALL : PricingType.FEATURED;
          return (
            <PriceContainer
              testId={getTestId(this.props.testId, 'PriceContainer')}
              data={this.props.data.price}
              options={{ type: pricingType, className: styles.planTitlePrice, decimalPoints: 2 }}
            />
          );
  
        } else {
          return (
            <Button
              data={{ ...this.props.data.priceButtonData.data }}
              events={{ ...this.props.data.priceButtonData.events }}
              options={{ ...this.props.data.priceButtonData.options }}
            />
          );
        }
      }
      */
    SelectedPlan.prototype.getIconFromOps = function (options) {
        var newIcons = { icons: icons };
        var iconFromMain = newIcons.icons[options.type];
        return [iconFromMain, styles.dtvPlanIcon];
    };
    Object.defineProperty(SelectedPlan.prototype, "ariaLabelContent", {
        get: function () {
            if (this.props.options && this.props.options.accessibility) {
                return this.props.options.accessibility;
            }
            return this.props.data.title;
        },
        enumerable: false,
        configurable: true
    });
    SelectedPlan.defaultProps = {
        options: {
            type: SelectedPlanProps_1.SelectedPlanType.DEFAULT,
        },
    };
    return SelectedPlan;
}(React.Component));
exports.default = SelectedPlan;
//# sourceMappingURL=SelectedPlan.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/SelectedPlan/SelectedPlan.js
// module id = 837
// module chunks = 8